<template>
  <div class="doencas-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Doencas')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Doencas')"
            :value="pet.doencas | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('doencas')"
          />
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Alergias')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Alimentos')"
            :value="pet.alergiaAlimentar | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('alergiaAlimentar')"
          />
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Medicamentos')"
            :value="pet.alergiaMedicamento | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['pet/isRestrict']('alergiaMedicamento')
            "
          />
        </v-col>
        <v-col class="mb-4" cols="12">
          <field-section
            :label="$t('Outros')"
            :value="pet.alergiaOutros | toPT_BRCapitalize"
            :is-restrict="$store.getters['pet/isRestrict']('alergiaOutros')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Doencas") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Doencas"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
};
</script>

<style scoped></style>
